import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const ReprintConfirmationModal = memo(function ReprintConfirmationModal({
  isOpen,
  onCancel,
  onSuccess,
  isBatch,
  isPlural,
  allPrinted,
  disabled = false,
  documentType,
}: {
  isOpen: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  isBatch: boolean;
  isPlural: boolean;
  allPrinted: boolean;
  disabled?: boolean;
  documentType: "label" | "packing slip";
}) {
  const documentName = isBatch
    ? "batch of " + documentType + "s"
    : documentType;

  const getMessage = () => {
    if (allPrinted) {
      if (isPlural) {
        return `These ${documentName}s were already printed.`;
      } else {
        return `This ${documentName} was already printed.`;
      }
    } else if (isPlural) {
      return `Some of these ${documentName}s were not printed.`;
    }

    return `This ${documentName} was already printed.`;
  };

  const subMessage = isPlural
    ? `Are you sure you'd like to print these ${documentName}s again?`
    : `Are you sure you'd like to print this ${documentName} again?`;
  const title = isPlural
    ? `Reprint ${documentName}s confirmation`
    : `Reprint ${documentName} confirmation`;
  return (
    <RedoModal
      isOpen={isOpen}
      modalSize="sm"
      onModalCloseRequested={onCancel}
      primaryButton={{
        text: "Confirm",
        onClick: async () => {
          onSuccess();
        },
        disabled,
      }}
      secondaryButton={{ text: "Cancel", onClick: onCancel }}
      title={title}
    >
      <Flex dir="column" gap="xl">
        <Text fontSize="md" fontWeight="thin" textColor="primary">
          {getMessage()}
        </Text>
        <Text fontSize="md" fontWeight="thin" textColor="primary">
          {subMessage}
        </Text>
      </Flex>
    </RedoModal>
  );
});
